<!--
 * @Author: Ztq
 * @Date: 2022-06-15 09:08:16
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-11-24 11:32:14
 * @Description: 
 * @FilePath: \ch2-template-vue\src\components\common\img-show\ImgShow.vue
-->
<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

interface Props {
  // TODO 铁球的代码
  file: any;
  style?: any;
}

const props = withDefaults(defineProps<Props>(), {
  file: null,
  style: {
    height: `${160}px`,
    width: `${120}px`,
    padding: `${3}px`,
    border: '1px solid #e8e8e8',
  },
});

const emits = defineEmits(['fileResult']);

const imgUrl = ref('');

onMounted(async () => {
  await nextTick();
});
</script>

<template>
  <div class="img-box" :style="style">
    <img v-if="imgUrl" :src="imgUrl" />
    <!-- <img v-else src="./default.png" alt="默认头像" /> -->
  </div>

  <slot name="upload"></slot>
</template>

<style type="text/css" lang="less">
.img-box {
  // border: 1px solid #e8e8e8;
  // height: 160px;
  // width: 120px;
  // padding: 3px;
  img {
    width: 100%;
    height: 100%;
  }
}

.up-btn {
  width: 120px;
  // border: 1px solid #e8e8e8;
  clear: both;
  button {
    width: 108%;
  }
}
</style>
